import React from 'react';
import {selectMemoizedProviderSessions} from 'features/Provider/providerSelectors';
import {MemberProfile} from 'interfaces';
import {useSelector} from 'react-redux';
import {formatTimeRangeWithOffset} from 'utils';

import {RevenueItem} from '../components/RevenueItem';
import {RevenueSession} from '..';

export default function SingleSession() {
  const memoizedSessions = useSelector(selectMemoizedProviderSessions);
  return (
    <RevenueSession>
      <>
        {memoizedSessions?.map(session => {
          return (
            <RevenueItem
              key={session?._id}
              client={session?.patientDetails?.fullName}
              memberType={session?.patientDetails?.accountType}
              appointmentType={session?.appointmentType}
              appointmentLabel={session?.appointmentLabel}
              insuranceName={
                session?.patientDetails?.insuranceDetails?.companyName ?? 'N/A'
              }
              sessionTime={formatTimeRangeWithOffset(
                session?.sessionDate,
                Number(session?.duration),
                false,
              )}
              sessionDate={session?.sessionDate}
              duration={session?.duration}
              sessionId={session?.appointmentId}
              user={session?.patientDetails as MemberProfile}
              isBillable={session?.isBillable}
              stages={session?.stages?.map(stage => ({
                name: stage?.stage,
                status: stage?.stageStatus,
                shouldBeChecked: stage?.shouldBeChecked,
                tooltip: stage?.tooltip,
              }))}
            />
          );
        })}
      </>
    </RevenueSession>
  );
}
